import {initPriceMarkerClass, IPriceMarker, PriceMarker} from "./PriceMarker";
import {Kachel} from "../structs/Kachel";
import {Search} from "../Search";
import {IKachelInfoBox, initKachelInfoBoxClass} from "./KachelInfoBox";
import {loadScript} from "../tools/loadScript";
import {GpsBound, GpsPos} from "./igps";
import {BoundHelper} from "./BoundHelper";

export class SearchMap {
    static mapActive: boolean
    static mapReady: boolean
    static map: google.maps.Map;
    static boundHelper: BoundHelper;

    static priceMarker: IPriceMarker[] = [];

    static updateMarker(kacheln: Kachel[]) {
        if (!SearchMap.map) return;
        for (let i = 0; i < SearchMap.priceMarker.length; i++) {
            SearchMap.priceMarker[i].setMap(null);
        }
        SearchMap.updateInfoBox(null);
        SearchMap.hoverCount = 0;
        SearchMap.priceMarker = [];
        let bound = new google.maps.LatLngBounds();
        for (let i = 0; i < kacheln.length; i++) {
            bound.extend((new GpsPos(kacheln[i].map_pos)).google());
            SearchMap.priceMarker.push(new PriceMarker(Search.kacheln[i], $('#map-content'), SearchMap.map));
        }
        if (kacheln.length && !SearchMap.boundHelper.liveSearch) {
            SearchMap.map.fitBounds(bound, {top: 60});
            SearchMap.boundHelper.updateView();
        }
    }

    static hoverCount: number = 0;

    static hoverMarker(target: number) {
        for (let i = 0; i < SearchMap.priceMarker.length; i++) {
            const ov = SearchMap.priceMarker[i];
            ov.hover(ov.kachel.target == target);
        }
        if (target != 0) this.hoverCount++; else this.hoverCount--;
    }

    static lastInfoBox: IKachelInfoBox | null;

    static updateInfoBox(infoBox: IKachelInfoBox | null) {
        if (SearchMap.lastInfoBox) SearchMap.lastInfoBox.setMap(null);
        SearchMap.lastInfoBox = infoBox;
    }

    static ready() {
        initPriceMarkerClass();
        initKachelInfoBoxClass();

        const divs = $('#map-content')
        if (!divs.length) {
            console.log("map: #map-content not found");
            return;
        }

        const filter = Search.filter;
        const ext = Search.filterExt;

        let bnd = new GpsBound("");
        if (filter.place_id > 0 && ext.place_gps[filter.place_id]) bnd = new GpsBound(ext.place_gps[filter.place_id])
        else if (filter.region_id > 0 && ext.region_gps[filter.region_id]) bnd = new GpsBound(ext.region_gps[filter.region_id])
        else if (filter.country_id > 0 && ext.country_gps[filter.country_id]) bnd = new GpsBound(ext.country_gps[filter.country_id])

        const center = bnd.valid ? bnd.center.google() : new google.maps.LatLng(28.0833928, -17.3340191);

        SearchMap.map = new google.maps.Map(divs[0], {
            center: center,
            mapTypeId: google.maps.MapTypeId.TERRAIN,
            zoom: 15,
            minZoom: 6,
            scaleControl: true,
            clickableIcons: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            scrollwheel: true,
        });
        SearchMap.map.addListener("zoom_changed", () => {
            const currentType = SearchMap.map.getMapTypeId();
            let setMapType = SearchMap.map.getZoom() <= 16 ? google.maps.MapTypeId.TERRAIN : google.maps.MapTypeId.ROADMAP;
            if (currentType == google.maps.MapTypeId.SATELLITE || currentType == google.maps.MapTypeId.HYBRID) setMapType = currentType;
            if (currentType !== setMapType) {
                SearchMap.map.setMapTypeId(setMapType);
            }
        });
        SearchMap.map.addListener("click", () => {
            if (SearchMap.hoverCount == 0) SearchMap.updateInfoBox(null);
        });
        SearchMap.mapReady = true;
        console.log("map: ready.");

        SearchMap.boundHelper = new BoundHelper(SearchMap.map, (bounds) => {
            const b = GpsBound.fromGoogle(bounds);
            Search.filter.gps = {start: b.tl.toPosStr(), end: b.br.toPosStr()};
            Search.updateSearch();
        }, () => {
            Search.filter.gps = {start: "", end: ""};
            Search.updateSearch();
        });

        if (bnd.valid) {
            console.log("fit-bound", bnd.google().toString())
            SearchMap.map.fitBounds(bnd.google());
            SearchMap.boundHelper.updateView();
        }

        SearchMap.updateMarker(Search.kacheln);
    }

    static initMap() {
        if (SearchMap.mapActive) {
            return
        }
        SearchMap.mapActive = true;
        console.log("map: init");
        loadScript("https://kk.vacando.com/js/m1?lang=" + window.pageInfo.lang + "&callback=SearchMap.ready", null);
    }
}
